import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Icons";
import { URL_DASHBOARD } from "@/constants/urls";
import UserMenu from "./UserMenu";
import NotificationBell from "./NotificationBell";

export default function AuthHeader() {
  return (
    <Box as="header" bg="primary.800" w="full">
      <Flex
        alignItems="center"
        justifyContent="space-between"
        maxW="8xl"
        mx="auto"
        px={{ base: 6, md: 0 }}
        py={4}
      >
        <Flex as={Link} to={URL_DASHBOARD} alignItems="center" gap={4} className="focus-bordered">
          <Logo w={{ base: "40px", md: "60px" }} h={{ base: "36px", md: "56px" }} color="white" />
          <Flex
            borderLeftWidth="1px"
            borderLeftColor="white"
            h={{ base: "48px", md: "56px" }}
            alignItems="center"
            pl={{ base: 2, md: 4 }}
          >
            <Text color="white" textStyle="body.bold" fontSize={{ base: "14px", md: "16px" }}>
              Իմ Տվյալները
            </Text>
          </Flex>
        </Flex>

        <Flex
          alignItems="center"
          gap={6}
          position="relative"
          flexDirection={{ base: "row-reverse", md: "row" }}
        >
          <UserMenu />
          {/* <NotificationBell /> */}
          {/* <Flex alignItems="center" gap={2} pl="10px">
              <AmIcon w="24px" h="24px" />
              <Text color="white" textStyle="body.regular">
                Հայերեն
              </Text>
              <ArrowDownIcon w="10px" h="5px" color="white" />
            </Flex> TODO::: add language selector */}
        </Flex>
      </Flex>
    </Box>
  );
}
